






































import { Component, Inject, Vue } from 'vue-property-decorator'
import Item from './item.vue'
import ShowMore from '../showMore/index2.vue'
import Deliver from '../deliver.vue'
import { ShopTypes } from '../../config'
import { toV, toCzj } from '@/app/core/utils'
import { uid, getSelectedCityId } from '@utils/index'
import { Cell, Tab, Tabs } from 'vant'

import { namespace } from 'vuex-class'
const shopHomeModule = namespace('shopHome')

interface ICommentDetail {
  praiseRate: string | number
  count: string | number
  list: []
}
@Component({
  components: {
    [Cell.name]: Cell,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    Item,
    ShowMore,
    Deliver,
  },
})
export default class Comment extends Vue {
  @Inject({ default: null })
  allCommentTrackParams!: any
  
  @shopHomeModule.State shopType!: ShopTypes
  @shopHomeModule.State shopYuer!: boolean
  @shopHomeModule.State shopDetail!: any
  @shopHomeModule.State commentDetail!: ICommentDetail

  // tabSelect = 4
  readonly Children: ShopTypes = ShopTypes.Children

  // TODO 评价类别
  // get tagList() {
  //   return [
  //     { text: '有图', value: '1' },
  //     { text: '服务质量', value: '2' },
  //     { text: '技巧型', value: '3' },
  //   ]
  // }

  get commentList() {
    return this.commentDetail.list
  }
  created() {
    console.log('dsadsadsa', this.commentDetail)
  }

  // changeTag(index: number) {
  //   const { value } = this.tagList[index]
  //   this.tabSelect = index
  // }

  showMoreComment() {
    this.allCommentTrackParams && this.$newClickTracker(this.allCommentTrackParams)
    // 育儿的查看更多评论跳转逻辑不动，成长加的查看更多跳转到成长加
    if (this.shopYuer) {
      // 跳到原有评论列表页面，传参’comeFrom：newHome‘
      // 原评论列表根据此字段做判断，显示type为9，businessId为门店businessId的评论数
      // 注意，底部”显示对你帮助不大的评论“也需要根据这个字段做区分
      toV({
        name: 'comment-list',
        params: {
          workerCode: this.shopDetail.businessKey,
        },
        query: {
          /* eslint-disable @typescript-eslint/ban-ts-comment */
          //@ts-ignore
          userType: 2,
          uid: uid,
          businessId: this.shopDetail.businessKey,
          comeFrom: 'newHome',
        },
      })
    } else {
      toCzj(`https://m.czj100.com/comment/${this.shopDetail.businessKey}?type=1&title=${this.shopDetail.storeName}`)
    }
  }
}
